// longitude = d'est en ouest
// latitude = du nord au sud

const placesContainer = document.getElementById("mm-map-places");
if (placesContainer) {
	const placeCardTemplate = document.getElementById("mm-map-place-template");

	const placesJSONEl = document.querySelector("#mm-places-json .metafield-json");
	const mapboxTokenInput = document.getElementById("mm-mapbox-token");
	const geocoderWrapper = document.querySelector('.mm-map-wrapper #mm-map-geocoder');

	const PLACE_SELECTED_CLASS = "selected";
	const MARKER_DEFAULT_COLOR = "#021208";
	const MARKER_SELECTED_COLOR = "#FF0000";

	mapboxgl.accessToken = mapboxTokenInput.value;
	const places = JSON.parse(placesJSONEl.innerText).map((placeData) => {
		return {
			name: placeData.name,
			phone: placeData.phone,
			address: placeData.address,
			country: placeData.country,
			coordinates: [placeData.Longitude, placeData.Latitude],
		};
	});

	function mmInsertPlaceCard(place) {
		const card = placeCardTemplate.content.cloneNode(true).firstElementChild;
		
		const nameEl = card.querySelector("[data-place-name]");
		nameEl.textContent = place.name;

		const addressEl = card.querySelector("[data-place-address]");
		addressEl.textContent = place.address;

		card.dataset.placeCoordinates = JSON.stringify(place.coordinates);

		const countryEl = card.querySelector("[data-place-country]");
		if (document.querySelector(`.mm-cards-container-${place.country}`)) {
			document.querySelector(`.mm-cards-container-${place.country}`).appendChild(card);
		} else {
			const parentContainer = document.createElement("div");
			placesContainer.appendChild(parentContainer);
			parentContainer.classList.add(`mm-cards-container-${place.country}`);
			const containerTitle = `<p class="">${place.country}</p>`;
			parentContainer.insertAdjacentHTML("afterBegin", containerTitle);
			parentContainer.appendChild(card);
		}
	}

	function mmDisplayVisibleMarkers(map) {
		const {
			_ne: {lng: maxEast, lat: maxNorth},
			_sw: {lng: maxWest, lat: maxSouth},
		} = map.getBounds();

		const visiblePlaces = places.forEach((place) => {
			const [lng, lat] = place.coordinates; // [-1.557900, 47.214370]

			const visible = lng < maxEast && lng > maxWest && lat > maxSouth && lat < maxNorth;
			if (visible) {
				mmInsertPlaceCard(place);
			}
		});
	}

	function mmFlyToPlaceByCoordinates(coordinates) {
		const map = window.mmMap;
		map.flyTo(
			{center: coordinates, zoom: 15}, 
			{placeCoordinatesToSelect: coordinates}
		);
	}

	function mmSelectPlaceByCoordinates(coordinates) {
		Array.from(placesContainer.children).forEach((placeCard) => {
			placeCard.classList.remove(PLACE_SELECTED_CLASS);

			const [cardLng, cardLat] = JSON.parse(placeCard.dataset.placeCoordinates);
			const [lng, lat] = coordinates;
			if (cardLng === lng && cardLat === lat) {
				placeCard.classList.add(PLACE_SELECTED_CLASS);
			}
		});

		mmHighLightPlaceMarkerByCoordinates(coordinates);
	}

	function mmHighLightPlaceMarkerByCoordinates(coordinates) {
		const [lng, lat] = coordinates;
		const markers = document.querySelectorAll("#mm-map [data-marker-place-coordinates]");

		markers.forEach((marker) => {
			const [markerLng, markerLat] = JSON.parse(marker.dataset.markerPlaceCoordinates);
			const markerPath = marker.querySelector("path");

			if (markerLng === lng && markerLat === lat) {
				markerPath.setAttribute("fill", MARKER_SELECTED_COLOR);
			} else {
				markerPath.setAttribute("fill", MARKER_DEFAULT_COLOR);
			}
		});
	}

	function mmInitMap() {
		const map = new mapboxgl.Map({
			container: "mm-map",
			style: "mapbox://styles/mapbox/streets-v12",
			center: [2.25, 46.45],
			zoom: 4,
		});

		window.mmMap = map;

		// Ajout du champ de recherche
		const geocoder = new MapboxGeocoder({
			mapboxgl: mapboxgl,
			accessToken: mapboxgl.accessToken,
			placeholder: 'Entrez un code postal ou une adresse...',
			countries: "de,au,ie,ca,gb,ch,se,ae,jp,qa,it,fr,gf",
		});
		geocoderWrapper.appendChild(geocoder.onAdd(map));

		// Ajout du contrôle de géolocalisation
		map.addControl(
			new mapboxgl.GeolocateControl({
				positionOptions: {enableHighAccuracy: true},
				trackUserLocation: true,
				showUserHeading: true,
			})
		);

		// Conversion des lieux en GeoJSON
		const geojson = {
			type: "FeatureCollection",
			features: places.map((place) => ({
				type: "Feature",
				geometry: {type: "Point", coordinates: place.coordinates},
				properties: {
					name: place.name,
					phone: place.phone,
					address: place.address,
					country: place.country,
				},
			})),
		};

		map.on("load", () => {
			// Ajout de la source des clusters
			map.addSource("places", {
				type: "geojson",
				data: geojson,
				cluster: true,
				clusterMaxZoom: 14,
				clusterRadius: 50,
			});

			// Ajout du calque pour les clusters
			map.addLayer({
				id: "clusters",
				type: "circle",
				source: "places",
				filter: ["has", "point_count"],
				paint: {
					"circle-color": "#333333",
					"circle-radius": ["step", ["get", "point_count"], 40, 40, 50, 50, 40],
					"circle-stroke-width": 2,
					"circle-stroke-color": "#333333",
					"circle-stroke-opacity": 0.4,
				},
			});

			// Ajout du calque pour afficher le nombre de points dans les clusters
			map.addLayer({
				id: "cluster-count",
				type: "symbol",
				source: "places",
				filter: ["has", "point_count"],
				layout: {
					"text-field": "{point_count_abbreviated}",
					"text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
					"text-size": 12,
					"text-allow-overlap": true,
				},
				paint: {
					"text-color": "#ffffff", // ⚪ Texte blanc
				},
			});

			// Ajout du calque pour les points individuels
			map.addLayer({
				id: "unclustered-point",
				type: "circle",
				source: "places",
				filter: ["!", ["has", "point_count"]],
				paint: {
					"circle-color": MARKER_DEFAULT_COLOR,
					"circle-radius": 7,
					"circle-stroke-width": 2,
					"circle-stroke-color": "#333333",
					"circle-stroke-opacity": 0.4,
				},
			});

			// Clic sur un cluster → Zoom sur le groupe
			map.on("click", "clusters", (e) => {
				const features = map.queryRenderedFeatures(e.point, {layers: ["clusters"]});
				const clusterId = features[0].properties.cluster_id;
				map.getSource("places").getClusterExpansionZoom(clusterId, (err, zoom) => {
					if (err) return;
					map.easeTo({center: features[0].geometry.coordinates, zoom});
				});
			});

			// Clic sur un point individuel → Centrer sur ce point
			map.on("click", "unclustered-point", (e) => {
				const coordinates = e.features[0].geometry.coordinates.slice();
				mmFlyToPlaceByCoordinates(coordinates);
			});

      /* Affiche les cards au chargement de la page */
			mmDisplayVisibleMarkers(map);


			// Mise à jour des marqueurs affichés après déplacement de la carte
			map.on("moveend", (event) => {
				placesContainer.innerHTML = null;
				if (map.getZoom() > 2) mmDisplayVisibleMarkers(map);
				if (event.placeCoordinatesToSelect) mmSelectPlaceByCoordinates(event.placeCoordinatesToSelect);
			});

			// Clic sur une carte → Vol vers le lieu
			placesContainer.addEventListener("click", (event) => {
				const target = event.target.closest(".mm-map-place-card");
				if (target) mmFlyToPlaceByCoordinates(JSON.parse(target.dataset.placeCoordinates));
			});
		});
	}
}

document.addEventListener("DOMContentLoaded", function () {
	mmInitMap();

	// Déclenche un redimensionnement 200ms après init
	setTimeout(() => {
		window.dispatchEvent(new Event('resize'));
	}, 2000);
});
